<script>
import FormGroup from '@maison/components/form/FormGroup.vue';
import PasswordField from '@maison/components/form/fields/PasswordField';
import ResetPasswordForm from '@phoenix/mixins/components/form/myAccount/ResetPasswordForm';
import { defineAsyncComponent } from 'vue';

export default {
  components: {
    FormGroup,
    PhoenixForm: defineAsyncComponent(() => import('@maison/components/form/PhoenixForm.vue')),
    PasswordField,
  },

  mixins: [ResetPasswordForm],
};
</script>

<template>
  <div class="card card--white card--xl">
    <phoenix-form
      v-model="fields"
      :action="formAction"
      data-cy="reset-password-form"
      :captcha-enabled="false"
      :is-contained="false"
      :prefill-enabled="true"
      :redirect-url="redirectUrl"
      :blacklisted-fields-from-prefill-from-query="blacklistedFieldsFromPrefillFromQuery"
    >
      <div class="flex-grid flex-grid--x--md flex-grid--y--md">
        <div class="w-full">
          <form-group :attrs="fields.password">
            <password-field v-model="fields.password.value" />
          </form-group>
        </div>
        <div class="w-full">
          <form-group :attrs="fields.passwordConfirmation">
            <password-field v-model="fields.passwordConfirmation.value" />
          </form-group>
        </div>
      </div>
    </phoenix-form>
  </div>
</template>
